<template>
<!-- <PhoneInfoAgreementPage v-if="phoneLikeInfoCondition" @confirmed="phoneLikeUserAgreed = true"/> -->
<!-- It had to be that way because of incorrect stamps rendering -->
<div v-if="!pdfLoadingError" class="pdf-container scroll-bw mx-auto" ref="pdfContainer" style="max-width: 700px; max-height: 82vh; overflow-y: auto;">
  <PagesSelector
    v-if="countPages"
    :currentPage="currentPage"
    :count="countPages"
    @page-changed="goToPage"
  />
  <div class="pages">
    <div
      v-for="page in countPages"
      :key="page"
      class="page-wrapper"
      style="position: relative;"
    >
      <div
        :id="'pdfPage__' + page"
        :ref="'pdfPage__' + page"
        class="pdf-document__page"
        :style="currentPage === page ? 'border: solid 2px #E58C3F' : 'padding: 2px'"
      >
        <pdf
          v-if="pdfDocumentLoadingTask"
          :src="pdfDocumentLoadingTask"
          :page="page"
          style="width: 100%"
          @page-loaded="onLoadedPdfPage(page)"
        />
        <!-- Рендерим штампы ТОЛЬКО после загрузки страницы, чтобы контейнер имел правильные размеры -->
        <ParticipantStamps
          v-if="pageLoaded[page]"
          :page="page"
          :countPages="countPages"
          :pageContainerRefs="() => $refs"
          :pdfPages="pdfPages"
          :onlyForContact="targetContactForStamps"
          :stampsMap="stampsMap"
          :isReady="true"
        />
      </div>
    </div>
  </div>
  <v-overlay :value="overlayLoading">
    <div class="text-center">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      />
    </div>
  </v-overlay>
  <RefuseDialog v-model="refuseDialog" @confirmed="deny"/>
  <v-dialog v-model="dialog" max-width="590">
    <v-card>
      <v-card-title class="headline">Внимание!</v-card-title>
      <v-card-text>
        <div>
          Отправитель присоединил к документу Дополнительное Соглашение об
          электронном взаимодействии Сторон. Для продолжения необходимо
          принять и подписать Дополнительное Соглашение.
        </div>
      </v-card-text>
      <v-card-text class="pt-0">
        <a
          target="_blank"
          href="https://avissign.com/policy/additional-agreement/"
        >
          Просмотреть дополнительное Соглашение
        </a>
      </v-card-text>
      <v-card-text class="pt-0">
        <div>
          Отказ от подписания дополнительного соглашения будет означать отказ
          от подписания самого документа.
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn color="error" outlined tile dark class="ma-2" @click="refuse">
          Отказаться
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="#009933"
          tile
          :dark="true"
          class="ma-2"
          :disabled="false"
          @click="onSign()"
        >
          Подписать
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-navigation-drawer
    v-model="leftPanel"
    app
    clipped
    left
    :width="'300px'"
    @close="leftPanel = false"
  >
    <div v-for="(participant, i) in allMembers" :key="i + 'participant'" class="mx-2 my-3">
      <div>
        <div style="font-weight: 700;">
          {{participant.title}}
        </div>
        <div v-if="participant.actor" style="display: flex">
          <img :src="require(`@/assets/icons/${participant.actor.source}.svg`)" class="mr-2"/>
          <div>
            <div>
              {{participant.actor.name}}
            </div>
            <div style="font-size: 0.7rem">
              {{participant.actor.contact}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-navigation-drawer>
</div>
<div v-else-if="pdfLoadingError" style="display: flex; justify-content: center; align-items: center; flex-direction: column">
  <div>
    Что то пошло не так.
  </div>
  <div>
    Ошибка: {{ pdfLoadingError }}
  </div>
</div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import api from '@/utils/axios'
import { tryGetCurrentUser } from '@/utils/usersLegacy'
import SignaturesPlaceholder from '@/services/mixins/SignaturesPlaceholder'
import Pagination from '@/components/Pagination'
import ArrowCircle from '@/assets/icons/ArrowCircle.vue'
import CheckmarkCircle from '@/assets/icons/CheckmarkCircle.vue'
import DismissCircle from '@/assets/icons/DismissCircle.vue'
import { apiKey } from '@/api/configuration/config'
import { usePhoneConfirmationCommand } from '@/app/asyncStates/userStates'
import RefuseDialog from './ConfirmationForm/RefuseDialog.vue'
import { useRejectTransactionCommand } from '@/app/asyncStates/transactionStates'
// import PhoneInfoAgreementPage from '@/components/ConfirmationForm/PhoneInfoAgreementForm.vue'
import { useGenerateCodeCommand } from '@/app/asyncStates/identityConfirmationStates'
import { useAsyncStateErrorHandler } from '@/infranstructure/useAsyncStateErrorHandler'
import { ContactType, phoneLikeIdentities } from '@/models/digitalIdentities'
import ParticipantStamps from '@/components/pdfFormViewComponents/participantStamps/ParticipantStamps.vue'
import { isSigner, isApprover, hasStage, actorByPreactor } from '@/utils/transactionLegacy';
import { SignatureStage } from '@/models/TransactionData';
import PagesSelector from '@/components/pdfFormViewComponents/pdfForm/PagesSelector.vue';
import eventBus from '@/utils/eventBus'
import { getStampCacheKey, getOrLoadStamp, deleteStampCacheKey } from '@/services/stampCache';

export default {
  components: {
    Pagination,
    ArrowCircle,
    CheckmarkCircle,
    DismissCircle,
    RefuseDialog,
    // PhoneInfoAgreementPage,
    ParticipantStamps,
    PagesSelector,
  },
  mixins: [SignaturesPlaceholder],
  data() {
    return {
      currentUser: null,
      applyButtonElevation: null,
      pdfDocument: null,
      signPages: [],
      disableSignBtn: false,
      dialog: false,
      leftPanel: false,
      refuseDialog: false,
      alreadySignedPages: [],
      denied: false,
      signedSignatureIndexes: new Set(),
      currentSignatureIndex: 0,
      signedSignatureIndexesForceUpdate: 0,
      phoneCommand: usePhoneConfirmationCommand(apiKey, useAsyncStateErrorHandler),
      generateCodeForPhoneLikeIdentityCommand: useGenerateCodeCommand(apiKey, useAsyncStateErrorHandler),
      userPageChange: false,
      scrollHandler: null,
      stampsMap: {},
      previousContacts: [],
      pageLoaded: {}, // Флаги загрузки страниц для корректного размера штампов
    }
  },
  computed: {
    userSignatures() {
      const signatures = _.sortBy(_.filter(this.transaction?.documents[0].signatures, (signature) => signature.actor === this.currentUser?.contact),
        (signature) => signature.page)
      return signatures
    },
    overlayLoading() {
      return this.overlay || this.phoneCommand.isLoading || this.generateCodeForPhoneLikeIdentityCommand.isLoading
    },
    signedPageNumbers() {
      return _.map(Array.from(this.signedSignatureIndexes), (i) => this.userSignatures[i].page)
    },
    currentPageHasSignature() {
      return _.some(this.userSignatures, (signature) => signature.page === this.currentPage)
    },
    previousIndexes() {
      return _.range(0, this.currentSignatureIndex)
    },
    nextIndexes() {
      return _.range(this.currentSignatureIndex + 1, this.userSignatures.length)
    },
    previousBtnIsVisible() {
      const isVisible = _.some(this.previousIndexes, (i) => !this.signedSignatureIndexes.has(i)) ||
        (!this.currentPageHasSignature && this.currentPage > this.userSignatures[this.currentSignatureIndex]?.page)
      return isVisible
    },
    nextBtnIsVisible() {
      const isVisible = _.some(this.nextIndexes, (i) => !this.signedSignatureIndexes.has(i)) ||
        (!this.currentPageHasSignature && this.currentPage < this.userSignatures[this.currentSignatureIndex]?.page)
      return isVisible
    },
    allSignaturesIsSigned: {
      cache: false,
      get() {
        return this.signedSignatureIndexes.size === this.userSignatures.length
      },
    },
    currentUserParticipants() {
      if (!this.currentUser?.contact) return []
      return _.filter(this.participants, (participant) => participant.contact === this.currentUser.contact)
    },
    allUnsignedMembers() {
      const allMembers = _.uniqBy([this.transaction.author, ...this.transaction.actors, this.transaction.creator], 'contact')
      if (this.transaction.preAuthor) allMembers.push(this.transaction.preAuthor)
      const emails = _.map(_.uniqBy(_.filter(this.transaction.documents[0].signatures, (el) => !el.isSigned), 'actor'), (e) => e.actor)
      return _.filter(allMembers, (el) => emails.includes(el.contact))
    },
    allMembers() {
      const all = []
      if (!this.transaction) return []
      if (this.transaction.author.preActor) {
        all.push({
          title: 'Инициатор',
          actor: _.cloneDeep(this.transaction.author.preActor),
        })
      }
      all.push({
        title: 'Подписант: 1',
        actor: _.cloneDeep(this.transaction.author)
      })
      if (this.transaction.actors?.[0]?.preActor) all.push({
        title: 'Утверждающий',
        actor: _.cloneDeep(this.transaction.actors[0].preActor)
      })
      if (this.transaction.actors?.[0]?.preActor) {
        all.push({
          title: 'Утверждающий',
          actor: _.cloneDeep(this.transaction.actors[0].preActor),
        })
      }
      if (this.transaction.actors?.length) all.push(..._.map([this.transaction.actors], (el, index) => {
        return {
          title: `Подписант: ${index + 2}`,
          actor: _.cloneDeep(...el),
        }
      }))
      return all
    },
    participantsList() {
      return [...this.allUnsignedMembers]
    },
    targetContactForStamps() {
      if (!this.currentUser || !this.transaction) return null;
      // Если текущий пользователь — подписант
      if (this.isCurrentSigner) {
        return this.currentUser.contact;
      }
      // Если текущий пользователь — утверждающий
      if (this.isCurrentApprover) {
        // Найдём участника, за которого он утверждает
        const preActor = actorByPreactor(this.transaction, this.currentUser.contact);
        if (preActor) {
          return preActor.contact;
        }
        // fallback: возможно, он утверждает автора
        return this.transaction.author?.contact || null;
      }
      return null;
    },
    isCurrentSigner() {
      return isSigner(this.transaction, this.currentUser?.contact)
        && !hasStage(this.transaction, this.currentUser, SignatureStage.signed)
        && !hasStage(this.transaction, this.currentUser, SignatureStage.signingRejected);
    },
    isCurrentApprover() {
      if (!this.currentUser?.contact || !this.transaction) return false;
      const preActor = actorByPreactor(this.transaction, this.currentUser.contact);
      return (
        isApprover(this.transaction, this.currentUser.contact) &&
        preActor &&
        !hasStage(this.transaction, preActor, SignatureStage.signing)
      );
    },
  },
  watch: {
    // Загружаем штампы ТОЛЬКО при изменении списка контактов
    '$store.state.transaction': {
      deep: true,
      handler() {
        const currentContacts = this.getContactsFromTransaction();
        // Сравниваем отсортированные массивы для корректного определения изменений
        const prevSorted = [...this.previousContacts].sort();
        const currSorted = [...currentContacts].sort();
        const contactsChanged = prevSorted.length !== currSorted.length || 
          prevSorted.some((val, idx) => val !== currSorted[idx]);
        
        if (contactsChanged) {
          this.previousContacts = [...currentContacts];
          this.loadAllStamps();
        }
      }
    }
  },
  async mounted() {
    await this.loadCurrentUser();
    // Сохраняем контакты ДО загрузки штампов, чтобы избежать двойного вызова через watch
    this.previousContacts = this.getContactsFromTransaction();
    await this.loadAllStamps();
    
    eventBus.$on('sign', () => {
      this.onSend()
    });
    eventBus.$on('refuse', () => {
      this.refuse()
    });
    eventBus.$on('approve', () => {
      this.approve();
    });
    this.bindScrollListener();
  },
  beforeDestroy() {
    eventBus.$off('sign');
    eventBus.$off('approve');
    eventBus.$off('refuse');
    this.unbindScrollListener();
    
    // Освобождаем ресурсы штампов
    Object.values(this.stampsMap).forEach(stamp => {
      if (stamp.blobUrl) {
        URL.revokeObjectURL(stamp.blobUrl);
      }
    });
    this.stampsMap = {};
  },
  methods: {
    getContactsFromTransaction() {
      const transaction = this.$store.state.transaction;
      if (!transaction) return [];
      const contacts = [];
      if (transaction.author?.contact) contacts.push(transaction.author.contact);
      if (transaction.preAuthor?.contact) contacts.push(transaction.preAuthor.contact);
      if (transaction.actors) {
        transaction.actors.forEach((actor) => {
          if (actor.contact) contacts.push(actor.contact);
          if (actor.preActor?.contact) contacts.push(actor.preActor.contact);
        });
      }
      return _.uniq(contacts.filter(c => c));
    },
    
    async loadAllStamps() {
      const contacts = this.getContactsFromTransaction();
      if (contacts.length) {
        await this.loadStampsForContacts(contacts);
      }
    },
    
    async loadStampsForContacts(contacts) {
      const transactionId = this.sessionId;
      const userId = this.senderId;
      
      // Очищаем старые штампы и кэш ДЛЯ этих контактов
      contacts.forEach(contact => {
        const key = getStampCacheKey(transactionId, contact, userId);
        deleteStampCacheKey(key);
        if (this.stampsMap[contact]) {
          URL.revokeObjectURL(this.stampsMap[contact].blobUrl);
        }
        Vue.delete(this.stampsMap, contact);
      });
      
      // Загружаем штампы с использованием кэша
      await Promise.all(contacts.map(async contact => {
        const key = getStampCacheKey(transactionId, contact, userId);
        try {
          // getOrLoadStamp вернет { blobUrl, ratio } из кэша или загрузит новый
          const stamp = await getOrLoadStamp(key, () => this.loadAddedUserStampRaw(contact));
          Vue.set(this.stampsMap, contact, stamp);
        } catch (error) {
          console.error(`Error loading stamp for contact ${contact}:`, error);
        }
      }));
    },
    
    // Возвращает { blob, ratio } для кэширования (НЕ создает blobUrl!)
    async loadAddedUserStampRaw(contact) {
      const response = await api.get('/SignatureStamps/AddedStamp', {
        params: {
          transactionId: this.sessionId,
          actorContact: contact, // contact всегда строка здесь
          userId: this.senderId,
          _t: Date.now()
        },
        responseType: 'blob'
      });
      
      const blob = response.data;
      const ratio = await this.getImageAspectRatioFromBlob(blob);
      return { blob, ratio };
    },
    
    getImageAspectRatioFromBlob(blob) {
      return new Promise((resolve) => {
        const url = URL.createObjectURL(blob);
        const img = new Image();
        img.onload = () => {
          URL.revokeObjectURL(url);
          resolve(img.width / img.height);
        };
        img.onerror = () => {
          URL.revokeObjectURL(url);
          resolve(4);
        };
        img.src = url;
      });
    },
    
    // Фикс размера штампа: рендерим штампы ТОЛЬКО после загрузки страницы PDF
    onLoadedPdfPage(page) {
      const waitForSize = () => {
        const container = this.getPdfPageContainer(page);
        if (container && container.offsetWidth > 0 && container.offsetHeight > 0) {
          setTimeout(() => {
            Vue.set(this.pageLoaded, page, true);
          }, 200);
        } else {
          requestAnimationFrame(waitForSize);
        }
      };
      requestAnimationFrame(waitForSize);
    },
    
    bindScrollListener() {
      const root = this.$refs.pdfContainer;
      if (!root) return;
      this.scrollHandler = () => {
        this.userPageChange = false;
        const container = this.$refs.pdfContainer;
        if (!container) return;
        const containerRect = container.getBoundingClientRect();
        const scrollTop = container.scrollTop;
        const clientHeight = container.clientHeight;
        let mostVisiblePage = 1;
        let maxVisibleArea = 0;
        for (let i = 1; i <= this.countPages; i++) {
          const el = this.$refs[`pdfPage__${i}`];
          let target = null;
          if (Array.isArray(el)) {
            target = el.find(item => item instanceof HTMLElement) || null;
          } else if (el instanceof HTMLElement) {
            target = el;
          }
          if (!target) continue;
          const rect = target.getBoundingClientRect();
          const pageTop = rect.top - containerRect.top + scrollTop;
          const pageBottom = pageTop + target.offsetHeight;
          const visibleTop = Math.max(pageTop, scrollTop);
          const visibleBottom = Math.min(pageBottom, scrollTop + clientHeight);
          const visibleHeight = Math.max(0, visibleBottom - visibleTop);
          if (visibleHeight > maxVisibleArea) {
            maxVisibleArea = visibleHeight;
            mostVisiblePage = i;
          }
        }
        if (maxVisibleArea > 10 && !this.userPageChange) {
          this.$store.dispatch('setCurrentPage', mostVisiblePage);
        }
      };
      root.addEventListener('scroll', this.scrollHandler);
    },
    unbindScrollListener() {
      const root = this.$refs.pdfContainer;
      if (root && this.scrollHandler) {
        root.removeEventListener('scroll', this.scrollHandler);
        this.scrollHandler = null;
      }
    },
    async openConfirmationPhoneForm(response) {
      this.$router.push(`/phoneconfirmation/${response}/${this.sessionId}/${this.senderId}`)
    },
    async openConfirmationPhoneLikePage(payload, identityType) {
      this.$router.push({
        name: 'phone-like-confirmation',
        params: { payload },
        query: { id: this.sessionId, uid: this.senderId, identityType: identityType },
      })
    },
    async loadCurrentUser() {
      this.currentUser = await tryGetCurrentUser(this.sessionId, this.senderId)
    },
    async onSend() {
      this.disableSignBtn = true
      if (this.transaction.hasAdditionalAgreement) {
        this.dialog = true
        return
      }
      await this.sign()
    },
    async onSign() {
      this.dialog = false
      await this.sign()
    },
    async sign() {
      if (this.currentUser.source === ContactType.Phone) {
        const payload = btoa(JSON.stringify({
          transactionId: this.sessionId,
          phone: this.currentUser.contact,
        }))
        await this.phoneCommand.execute(0, payload)
        this.openConfirmationPhoneForm(this.phoneCommand.state.data)
        return
      }
      if (phoneLikeIdentities.includes(this.currentUser.source)) {
        const payload = btoa(JSON.stringify({
          transactionId: this.sessionId,
          digitalIdentityVerificationType: this.currentUser.source,
          digitalIdentity: this.currentUser.contact,
        }))
        const generateCodeResponse = await this.generateCodeForPhoneLikeIdentityCommand.execute(0, { type: this.currentUser.source, data: payload })
        this.openConfirmationPhoneLikePage(generateCodeResponse.data, this.currentUser.source)
        return
      }
      this.overlay = true
      if (this.transaction) {
        this.fetchSign()
      }
    },
    async fetchSign() {
      this.dialog = false
      this.disableSignBtn = true
      this.overlay = true
      const { sessionId, senderId } = this
      await api.get(
        `/transactions/${sessionId}/sign?uid=${senderId}&result=true`,
      )
      await this.$store.dispatch('uploadTransaction', {
        sessionId,
        senderId,
      })
      document.location.reload(true)
      this.overlay = false
    },
    async deny(reasonPhrase) {
      this.dialog = false
      this.refuseDialog = false
      this.disableSignBtn = true
      this.denied = true
      this.overlay = true
      const { sessionId, senderId } = this
      const rejectCommand = useRejectTransactionCommand(sessionId, senderId)
      await rejectCommand.execute(0, reasonPhrase)
      await this.$store.dispatch('uploadTransaction', {
        sessionId,
        senderId,
      })
      document.location.reload(true)
      this.overlay = false
    },
    async approve() {
      this.overlay = true;
      if (this.transaction) {
        if (this.transaction.hasAdditionalAgreement) {
          this.dialog = true;
        } else {
          await this.fetchApprove();
        }
      }
    },
    async fetchApprove() {
      this.dialog = false;
      this.overlay = true;
      const { sessionId, senderId } = this;
      await api.get(`/transactions/${sessionId}/approve?uid=${senderId}&result=true`);
      await this.$store.dispatch('uploadTransaction', { sessionId, senderId });
      document.location.reload(true);
      this.overlay = false;
    },
    signatureIsSigned(page) {
      const i = _.findIndex(this.userSignatures, (signature) => signature.page === page)
      return this.signedSignatureIndexes.has(i)
    },
    refuse() {
      this.refuseDialog = true
    },
    nextUnsignedIndex() {
      const index = _.find(this.nextIndexes, (i) => !this.signedSignatureIndexes.has(i))
      return index
    },
    previousUnsignedIndex() {
      const orderedPreviousIndexesByDesc = _.orderBy(this.previousIndexes, (i) => i, 'desc')
      const index = _.find(orderedPreviousIndexesByDesc, (i) => !this.signedSignatureIndexes.has(i))
      return index
    },
    nextSignature() {
      if (this.currentPage >= this.countPages || (this.currentSignatureIndex === this.userSignatures.length - 1 && this.currentPageHasSignature)) return
      const pageOfCurrentSignature = this.userSignatures[this.currentSignatureIndex]?.page
      if (!pageOfCurrentSignature) return
      if (this.currentPageHasSignature || pageOfCurrentSignature <= this.currentPage) {
        const index = this.nextUnsignedIndex()
        this.currentSignatureIndex = index != null ? index : this.currentSignatureIndex
        const page = this.userSignatures[this.currentSignatureIndex]?.page
        this.currentPage = page != null ? page : 1
      } else if (pageOfCurrentSignature > this.currentPage) {
        this.currentPage = pageOfCurrentSignature
      }
    },
    previousSignature() {
      if (this.currentPage < 1 || this.currentSignatureIndex < 0 || (this.currentSignatureIndex === 0 && this.currentPageHasSignature)) return
      const pageOfCurrentSignature = this.userSignatures[this.currentSignatureIndex]?.page
      if (!pageOfCurrentSignature) return
      if (this.currentPageHasSignature || pageOfCurrentSignature >= this.currentPage) {
        const index = this.previousUnsignedIndex()
        this.currentSignatureIndex = index != null ? index : this.currentSignatureIndex
        const page = this.userSignatures[this.currentSignatureIndex]?.page
        this.currentPage = page != null ? page : 1
      } else if (pageOfCurrentSignature < this.currentPage) {
        this.currentPage = pageOfCurrentSignature
      }
    },
    signPage() {
      this.signedSignatureIndexes.add(this.currentSignatureIndex)
      this.signedSignatureIndexesForceUpdate++
    },
    currentPageIsChanged(page) {
      const currentSignatureIndexByPage = _.findIndex(this.userSignatures, (signature) => signature.page === page)
      if (currentSignatureIndexByPage > -1) this.currentSignatureIndex = currentSignatureIndexByPage
    },
    goToPage(page) {
      if (page < 1 || page > this.countPages) return;
      this.userPageChange = true;
      if (this.currentPage === page) return
      this.$store.dispatch('setCurrentPage', page);
      
      this.$nextTick(() => {
        const root = this.$refs.pdfContainer;
        if (!root) return;

        const refs = this.$refs[`pdfPage__${page}`];
        const el = Array.isArray(refs) ? refs[0] : refs;
        if (!el) return;
        
        const target = el.$el || el;
        
        // ✅ Вычисляем позицию элемента ОТНОСИТЕЛЬНО pdfContainer
        const rootRect = root.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();
        const targetTop = targetRect.top - rootRect.top + root.scrollTop;

        // ✅ Прокручиваем ТОЛЬКО pdfContainer, не трогая родительские элементы
        root.scrollTo({
          top: targetTop,
          behavior: 'smooth',
        });
      });
    }
  },
}
</script>

<style>
hr {
  border-color: lightgray !important;
  height: 5rem !important;
}
.v-input__slot {
  margin-bottom: 0 !important;
}
.noMessages .v-messages {
  display: none;
}
</style>

<style lang="scss" scoped>
.pdf-document {
  .pdf-document__page {
    position: relative;
  }
  gap: 30px;
  display: flex;
  flex-direction: column;
}
</style>

<style lang="scss">
.pdf-document {
  .pdf-document__page {
    position: relative;
  }
  gap: 30px;
  display: flex;
  flex-direction: column;
}
.pdf-form-locally-classes {
  // max-height: 70vh;
  // overflow-y: scroll;
  overflow-x: clip;
}
.green-bordered-btn {
  border: 1px solid #009933;
  color: #009933;
  border-radius: 4px;
  font-size: 16px;
  width: 150px;
  height: 34px;
}
.page-select-btn {
  height: 30px;
  width: 22px;
  border: solid 1px #4F4F4F;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.v-badge.page-select-element {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 7px;
  cursor: pointer
}
span .v-badge__badge {
  top: -6px !important;
  right: 14px !important;
  height: 13px !important;
  min-width: 10px !important;
  display: flex !important;
}
@mixin scroll-style($size: 10px,
$thumb: none,
$thumb-color: grey,
$thumb-radius: 10px,
$track-color: transparent,
$track-radius: 10px) {
  // Respaldo para Firefox
  scrollbar-color: $thumb-color $track-color;
  scrollbar-width: thin;
  // Navegadores basados en webkit
  &::-webkit-scrollbar {
    width: $size;
    height: $size;
    &-track {
      background-color: $track-color;
      border-radius: $track-radius;
    }
    &-thumb {
      background-color: $thumb-color;
      background-image: $thumb;
      border-radius: $thumb-radius;
    }
  }
}
.scroll {
  @include scroll-style(
    $size: var(--scroll-size, 10px),
    $thumb:  var(--scroll-thumb, none),
    $thumb-color: var(--scroll-thumb-color, grey),
    $thumb-radius: var(--scroll-thumb-radius, var(--scroll-radius)),
    $track-color: var(--scroll-track, transparent),
    $track-radius: var(--scroll-track-radius, var(--scroll-radius)),
  );
  &-bw {
    --scroll-size: 5px;
    --scroll-radius: 10px;
    --scroll-track: rgb(223, 223, 223);
    --scroll-thumb-color: #9c9c9c;
  }
  &-bw-7 {
    --scroll-size: 6px;
    --scroll-radius: 10px;
    --scroll-track: rgb(223, 223, 223);
    --scroll-thumb-color: #9c9c9c;
  }
}
.pdf-container {
  overflow-x: hidden !important;
  overflow-y: auto !important;
  max-height: 82vh;
  display: block !important; /* подавляем влияние Vuetify */
}
.pages {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 10px 0;
  margin-top: 2.5rem;
}
</style>